import './AgentPipeline.scss';
import Component from './AgentPipeline.js';
export default Component;
